import { render } from "./SurveyPatientFormModal.vue?vue&type=template&id=11cd21c2"
import script from "./SurveyPatientFormModal.vue?vue&type=script&lang=js"
export * from "./SurveyPatientFormModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__